import { Euler as o } from "three";
import { EulerToDegrees as r } from "./index6.js";
const t = new o(), s = (e) => r(
  t.setFromQuaternion(e)
);
export {
  s as QuaternionToDegrees
};
//# sourceMappingURL=index19.js.map
